export default __webpack_public_path__ + "static/media/fastTrackAppointments_580x400.8d56be48.jpg";